import React,{useEffect,useState} from "react";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as Actions from '../actions/Actions.js';
import LoadingStyleItem from "../components/LoadingStyleItem.js"
import LazyLoad from 'react-lazyload';
import StyleModal from '../components/StyleModal.js';
import Modal from 'react-bootstrap/Modal';
import Helper from "../functions/Helper.js";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {Link} from 'react-router-dom';
import orderBy from 'lodash/orderBy';

import {jsx} from '@emotion/react'

const onlyAvailableShoesFilter={filterType:{data:"colorway_amount",item:"# of available colorways",text:"# of available colorways",type:"bool",checkFunction:(shoe)=>shoe.colorway_amount<1}};

const calculateItemAmount=(containerWidth)=>{
  if(containerWidth<345){
    return 1
  }
  else if(containerWidth<576){
    return 2
  }
  else if(containerWidth<768){
    return 3
  }
  else if(containerWidth<992){
    return 4
  }
  else{
    return 8
  }
};

const loadStyles=()=>{
  return(fetch(__server__ + '/API/pub/popular_styles', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((response) =>response.json())
    .then((data)=>data)
  )
}


const loadSavedFilters=()=>{
  return fetch(__server__ + "/API/pub/all_filters", {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
    .then((response) =>response.json())
    .then((data)=>Helper.migrateFilter(data.sort((a,b)=>a.orderNumber-b.orderNumber)))
}



function Discover(props){
  const flexGap=5;
  const [itemWidth,setItemWidth]=useState(0);
  const [containerWidth,setContainerWidth]=useState(0);
  const [showModal, setShowModal] = useState(false);
  const [activeStyle,setActiveStyle]=useState({});
  const [styles,setStyles]=useState([]);
  const [savedFilters,setSavedFilters]=useState([]);
  const [expanded,setExpanded]=useState({});

  useEffect(()=>{
    loadStyles().then((data)=>setStyles(data));
    loadSavedFilters().then((data)=>setSavedFilters(data));

  },[])

  const expand=(filter,value)=>{
    setExpanded({...expanded,[filter.filter_id]:value})
  }

  const onResize=(x)=>{
    setContainerWidth(document.getElementById("like_container").offsetWidth);
  }

  useEffect(()=>{
    setItemWidth((containerWidth/calculateItemAmount(containerWidth))-flexGap);
  },[containerWidth]);


  useEffect(()=>{
    window.addEventListener('resize', onResize);
  },[]);

  useEffect(()=>{
    setContainerWidth(document.getElementById("like_container").offsetWidth);
  },[]);

  return(
    <div>
      <div id="like_container" style={{minHeight:"100vh",marginRight:-10}}>
        <Modal dialogClassName="thg_style_modal" onHide={()=>{setShowModal(false)}} show={showModal}>
          <StyleModal linkId={props.linkId} hideModal={()=>{setShowModal(false)}} activeStyle={activeStyle} shoe={{shoe_name:activeStyle.shoe_name,url:activeStyle.shoe_url}}/>
        </Modal>
        <h3 style={{marginBottom:30}} className="thg_h4_size thg_header" >The most popular colorways:</h3>
        <div style={{flexDirection:"row",marginTop:10,display:"flex",flexWrap:"wrap",marginBottom:80}}>
          {styles.slice(0,8).map((style)=>
            <LazyLoad placeholder={<div style={{minHeight:200,width:itemWidth}}/>} key={style.style_id}>
              <div style={{marginRight:flexGap,marginBottom:50,}}>
                <LoadingStyleItem
                  onClick={(style)=>{setShowModal(true);setActiveStyle(style)}}
                  textContainerStyle={{padding:"5px 20px 10px 5px"}}
                  key={style.style_id}
                  style_id={style.style_id}
                  showShoeName
                  showLikeButton={false}
                  imageProps={{padding:"5% 8%"}}
                  imageHeight={itemWidth}
                  swiperWidth={itemWidth}  />
              </div>
            </LazyLoad>
          )}
        </div>
        <Row>

        {savedFilters.map((savedfilter,index)=>{
          let filters=[...JSON.parse(savedfilter.json),onlyAvailableShoesFilter];
          let shoes=orderBy(Helper.filterData(props.data,filters,""),[savedfilter.sortBy], savedfilter.sortOrder);

          return(
            <Col lg={6} style={{marginBottom:80,paddingRight:100}}>
              <h3 className="thg_h4_size thg_header" >{savedfilter.title}</h3>
              <div style={{marginBottom:30}}>
                {savedfilter.description}
              </div>
              {shoes.slice(0, expanded[savedfilter.filter_id] ? 10: 5).map((shoe,index)=>{
                return(
                  <div style={{display:"flex",marginBottom:15}}>
                    <div style={{flex:"0 0 130px"}}>
                      <Link to={"/shoe-reviews/" + shoe.url.toLowerCase() + "/"}>
                        <img style={{width:"100%",objectFit:"contain",objectPosition:"bottom",height:100,backgroundColor:"#f8f8f8",padding:"10px",transform: shoe.pictures[1].mirror==="1" && "scaleX(-1)" }}
                          sizes="150px"
                          srcSet={Helper.create_source_set(shoe.pictures[1])}
                          alt={shoe.shoe_name}/>
                      </Link>
                    </div>
                    <div style={{marginLeft:15}}>
                      <Link style={{lineHeight:1.2,color:"var(--grey-800)",fontWeight:600,fontSize:20}} to={"/shoe-reviews/" + shoe.url.toLowerCase() + "/"}>
                        {index+1  +". "+ shoe.shoe_name}
                      </Link>
                      <div style={{color:"var(--grey-700)"}}>
                        {shoe.best_text}
                      </div>
                    </div>
                  </div>
                )
              })}
              <div>
                {expanded[savedfilter.filter_id] ?

                  <div style={{cursor:"pointer",fontWeight:700,fontSize:16}} onClick={()=>{expand(savedfilter,false)}}>
                    + Collapse List to see less shoes
                  </div>
                  :
                  <div style={{cursor:"pointer", fontWeight:700,fontSize:16}} onClick={()=>{expand(savedfilter,true)}}>
                    + Expand list to see more shoes
                  </div>

                }
              </div>
            </Col>
          )}

        )}
        </Row>
      </div>
    </div>
  );
}


  export default connect(state => ({
    likes:state.persistData.likes,data:state.data.data
  }), (dispatch) => ({
    actions: bindActionCreators(Actions, dispatch)
  }))(Discover);
